
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.68 23.044a.367.367 0 01.483-.003c.251.23.658.23.91 0a1.421 1.421 0 011.882 0c.132.123.13.32-.003.442a.367.367 0 01-.483.003.687.687 0 00-.91 0 1.422 1.422 0 01-1.883 0 .296.296 0 01.004-.442z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M24.68 24.201a.367.367 0 01.483-.003c.251.23.658.23.91 0a1.421 1.421 0 011.882 0c.132.124.13.32-.003.443a.367.367 0 01-.483.003.687.687 0 00-.91 0 1.422 1.422 0 01-1.883 0 .296.296 0 01.004-.442z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"5.474","y":"7.632","width":"13.895","height":"12.737","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":"14","y":"22","width":"8","height":"6","rx":"1","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.421 3l9.025 6.079H3.396L12.421 3zM7.79 16.895h2.316v5.789H7.79zM24 22.684V25H7.79v-2.316z","fill":"currentColor"}})])
          )
        }
      }
    